import { Controller } from "stimulus";

export default class extends Controller {
  connect() {
    this.onLoad = () => this.hideOverlay();
    this.element.addEventListener("load", this.onLoad);
    this.element.addEventListener("error", this.onLoad);

    this.showOverlay();
  }

  disconnect() {
    this.element.removeEventListener("load", this.onLoad);
    this.element.removeEventListener("error", this.onLoad);

    this.hideOverlay();
  }

  showOverlay() {
    if (this.pending) return;

    this.pending = true;
    this.element.dispatchEvent(new CustomEvent("overlay:show", { bubbles: true }));
  }

  hideOverlay() {
    if (!this.pending) return;

    this.pending = false;
    this.element.dispatchEvent(new CustomEvent("overlay:hide", { bubbles: true }));
  }
}
